import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Grid, Dialog, DialogContent } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';
import "../../assets/css/reports.css";
import "../../assets/css/assetreport.css";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from '../commoncomponents/CustomTextFieldWithSearch';
import { getAuthToken, getcompanyId } from "../../utility/tokenUtility";
import { FemsGraph, BemsGraph } from "../../utility/apiURLS";
import Printfile from '../../components/conditionreportcomponents/Printfile';
import PageTitle from "../commoncomponents/PageTitle";
import { useDispatch } from "react-redux";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import CustomDialog from "../commoncomponents/CustomDialog";
import { ifacSecurityURL } from "../../utility/apiURLS";
import PageLoader from "../commoncomponents/PageLoader";
import axios from "axios";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';

const Appraisalreportfile = () => {
  const navigate = useNavigate();
  const[text,setText] = useState("");
  const[date,setDate]=useState("");
  const [readOnly, setReadOnly] = useState(false);
  const [readOnlyEdit, setReadOnlyEdit] = useState(false);
  const [assetNo, setAssetNo] = useState(null);
  const [options, setOptions] = useState([]);
  const [assetDescription, setAssetDescription] = useState('');
  const [service, setService] = useState('');
  const [showDetails, setShowDetails] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isView, setIsView] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const companyId = getcompanyId('companyId');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({
    assetNo: true,

  });
  const facilityId = localStorage.getItem('facilityId');
  const [errorMessages, setErrorMessages] = useState({
    assetNo: "",

  });
  const childRef = useRef(null);

  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGA003");


  const token = getAuthToken("id_token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const handleAssetNo = (newValue) => {
    setAssetNo(newValue ? { ...newValue, label: newValue.label.split('-')[0].trimRight() } : '');
    setAssetDescription(newValue.value);
    setService(newValue.serviceName || '');

    if (newValue) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        assetNo: false,
      }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        assetNo: "",
      }));
    }
    setText("");  // Reset text when hospital changes
    setDate("");  // Reset date when hospital changes
  };

  //  const fetcompanychOptions = async () => {
  //     try {
  //       const companysResponse = await axios.get(`${ifacSecurityURL}/api/seccompanyregisters/${companyId}`, config);

  //       setCompanyName(companysResponse.data.companyname);
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //   }

  useEffect(() => {
    if (!assetNo) {
      setService("");
      setAssetDescription("");
    }
  }, [assetNo]);

  // const handleAssetNoChange = (newValue) => {
  //   if (newValue) {
  //     setAssetNo(newValue ? { ...newValue, label: newValue.label.split('-')[0].trimRight() } : '');
  //     setService(newValue.serviceName || '');
  //     setAssetDescription(newValue.assetdesc || '');
  //     localStorage.setItem('defaultAssetNo', newValue.assetNo);
  //   } else {
  //     setAssetNo(null);
  //     setService("");
  //     setAssetDescription("");
  //   }
  // };
  const fetchOptions = async () => {

    const femsResponse = await Axios.get(`${FemsGraph}/api/GraphFemsAssetregisterlist/GetAssetRegisterListFetch/${facilityId}`, config);
    const bemsResponse = await Axios.get(`${BemsGraph}/api/GraphBemsAssetregisterlist/GetAssetRegisterListFetch/${facilityId}`, config);

    const combinedData = [...femsResponse.data, ...bemsResponse.data];

    const reArrangedData = combinedData.map((item) => ({
      label: `${item.assetNo} - ${item.assetdesc}`,
      value: item.assetdesc,
      assetNo: item.assetNo,
      id: item.id,
      serviceName: item.serviceName,
      assetdesc: item.assetdesc,
    }));

    setOptions(reArrangedData);

  };

  useEffect(() => {
    fetchOptions();
    // fetcompanychOptions();
  }, []);
  const handleCancel = () => {
    if (!assetNo && !assetDescription && !service) {
      navigate("/dashboard");
      dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
      dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
    } else {
      setCancelDialogOpen(true);
    }

  };
  const handleCancelConfirm = () => {
    setCancelDialogOpen(false);
    navigate("/dashboard");
    dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
    dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
  };
  const handleCancelDialogClose = () => {
    setCancelDialogOpen(false);
  };




  const fetchReportData = async () => {
    try {
      const assetId = assetNo?.id;
      const serviceName = assetNo?.serviceName; // Use serviceName to identify the source

      if (!assetId || !serviceName) {
        throw new Error("Asset ID and service name are required.");
      }

      let responseData;

      if (serviceName === "FEMS") {
        const femsResponse = await Axios.get(`${FemsGraph}/api/ConditionAppraisalReport/${assetId}?size=1000`, config);
        responseData = femsResponse.data[0]; // Assuming data is returned in an array
      } else if (serviceName === "BEMS") {
        const bemsResponse = await Axios.get(`${BemsGraph}/api/ConditionAppraisalReport/${assetId}?size=1000`, config);
        responseData = bemsResponse.data[0];
      } else if (serviceName === "All") {
        const femsResponse = await Axios.get(`${FemsGraph}/api/ConditionAppraisalReport/${assetId}?size=1000`, config);
        const bemsResponse = await Axios.get(`${BemsGraph}/api/ConditionAppraisalReport/${assetId}?size=1000`, config);

        // Combine responses if both are fetched
        responseData = { ...femsResponse.data[0], ...bemsResponse.data[0] };
      }

      setReportData(responseData); // Set the combined or single response data to state
      console.log(responseData, 'responseData');

    } catch (error) {
      console.error("Error fetching report data:", error);
    }
  };


  useEffect(() => {
    if (Object.keys(reportData).length > 0) {
    }
  }, [reportData]);

  const handleViewButtonClick = async () => {
    setIsView(true);
    if (!assetNo.label || !assetNo.id) {
      setErrors({
        assetNo: true,
      });
      setErrorMessages({
        assetNo: !assetNo.label ? "Asset No is required" : "",
      });
      return; // Early return if validation fails
    }

    setLoading(true);
    try {
      await fetchReportData(); // Fetch report data first
      setOpenModal(true);
    } catch (error) {
      console.error("Error while fetching report data:", error);
    } finally {
      setLoading(false); // Always turn off loading
    }
  };

  const handleDownloadPDF = async () => {  // Make the function async
    if (!assetNo || !assetNo.label || !assetNo.id) {
      setErrors({
        assetNo: true,
      });
      setErrorMessages({
        assetNo: !assetNo.label ? "Asset No is required" : "",
      });

      return;  // Stop execution if assetNo is invalid
    }

    // Await for the fetchReportData() function to finish
    await fetchReportData();

    setIsView(false);
    setOpenModal(true);

    // Delay the download to allow the modal to render
    setTimeout(() => {
      if (childRef.current) {
        childRef.current.handleDownloadPDF();  // Trigger PDF download in child component
      }

      // Close modal after the download is triggered
      setTimeout(() => {
        setOpenModal(false);
      }, 1000);  // Close the modal after 1 second
    }, 500);  // Delay of 500ms before downloading
  };




  return (
    <>
      <PageLoader open={loading} />
      <PageTitle title={"Asset Condition Appraisal Report"} />

      <Box mt={{ xs: 1, sm: 2 }}>
        <DefaultCard>
          <Grid container spacing={2}>
            <Grid item xs={6} md={4}>
              <CustomTextFieldWithSearch
                label="Asset No"
                name="Asset No"
                id="Asset No"
                options={options}
                value={assetNo}
                getOptionLabel={(option) => option.assetNo}
                isOptionEqualToValue={(option, value) => option.assetNo === value.assetNo}
                disabled={readOnly || readOnlyEdit}
                isMandatoryField={true}
                autoFocus={true}
                onChange={handleAssetNo}
                error={errors.assetNo}
                helperText={errorMessages.assetNo}
              />

            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Asset Description"
                name="Asset Description"
                disabled={readOnly || readOnlyEdit}
                isRefilByOtherField={true}
                placeholder={false}
                value={assetDescription}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Service"
                name="Service"
                disabled={readOnly || readOnlyEdit}
                isRefilByOtherField={true}
                placeholder={false}
                value={service}
              />
            </Grid>

          </Grid>

          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: { xs: "center", md: "end" },
              mt: 3,
            }}
          >
            <Button variant='contained' onClick={handleViewButtonClick}>View</Button>
            {access?.canPrint && <Button variant='contained' onClick={handleDownloadPDF}>Download </Button>}
            <Button variant='outlined' onClick={handleCancel}>Close</Button>

          </Box>
        </DefaultCard>
        <Dialog
          open={openModal}
          onClose={() => setOpenModal(false)} // This ensures the dialog closes when you click outside
          maxWidth="lg"
          fullWidth

          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            ...(!isView && {
              "& .MuiBackdrop-root": {
                backgroundColor: "transparent",
              },
              top: "-9999px",
              left: "-9999px",
              zIndex: "-1",
            })
          }}

        >
          <DialogContent>
            <Printfile
              assetNo={assetNo}
              service={service}
              assetDescription={assetDescription}
              setOpenModal={setOpenModal}
              reportData={reportData}
              ref={childRef}
              text={text}
              setText={setText}
              date={date}
              setDate={setDate}
            />
          </DialogContent>
        </Dialog>




      </Box>
      <CustomDialog
        open={cancelDialogOpen}
        onClose={handleCancelDialogClose}
        onConfirm={handleCancelConfirm}
        title="Cancel Confirmation"
        content="Do you want to continue?"
        cancelBtn="No"
        confirmBtn="Yes"
      />
    </>
  );
};

export default Appraisalreportfile;